<script>
  import { slide, fade } from "svelte/transition";
  import { circIn } from "svelte/easing";

  import { theme, isDownloadOpen } from "../../stores/store";
  import { currentQuote } from "../../stores/store";
  import Loading from "./loading.svelte";

  $: themeValue = $theme === "dark" ? 0 : 1;

  let generatingFile: boolean = false;
  let fileReady: boolean = false;
  let downloadLink: string;

  let downloadButtons = [
    {
      content: "Desktop",
      onClick: () => {
        generateFile("desktop");
      },
      icon: "desktop",
    },
    {
      content: "Mobile",
      onClick: () => {
        generateFile("mobile");
      },
      icon: "mobile",
    },
    {
      content: "Socials",
      onClick: () => {
        generateFile("socials");
      },
      icon: "hashtag",
    },
  ];

  let requestHeader: any = {
    method: "POST",
    "content-type": "application/json;charset=utf-8",
    body: { id: "", size: "" },
  };

  async function updateHeader(size: string) {
    requestHeader.body.size = size;
    requestHeader.body.id = $currentQuote["_id"] + themeValue;
    requestHeader.body = JSON.stringify(requestHeader.body);
  }

  async function generateFile(size: string) {
    generatingFile = true;
    updateHeader(size);
    let createScreenshot = await fetch(
      "/api/screenshot/get/?q=" + $currentQuote["_id"] + themeValue,
      requestHeader
    );
    let screenshot = await createScreenshot.json();
    requestHeader.body = JSON.parse(requestHeader.body);
    downloadLink = screenshot;
    fileReady = true;
  }

  function close() {
    let currentStatus = $isDownloadOpen ? false : true;
    generatingFile = false;
    fileReady = false;
    downloadLink = "";
    isDownloadOpen.set(currentStatus);
  }
</script>

{#if $isDownloadOpen}
  <div
    class="download-wrapper"
    in:slide={{ duration: 250, easing: circIn }}
    out:slide={{ delay: 150 }}
  >
    <div
      class="download-options"
      in:fade={{ duration: 250, delay: 250 }}
      out:fade={{ duration: 250 }}
    >
      {#if !generatingFile}
        {#each downloadButtons as button}
          <button
            class={$theme}
            on:click={button.onClick}
          >
            <i class="far fa-{button.icon} fa-2x" />
            <strong>Download for {button.content}</strong>
          </button>
        {/each}
      {:else if generatingFile}
        {#if !fileReady}
          <div class="loading-wrapper">
            <Loading />
            <h3>Generating Image...Patience is a Virtue</h3>
          </div>
        {:else}
          <a
            class="download-button {$theme}"
            href={downloadLink}
            download
          >
            <i class="far fa-arrow-to-bottom fa-2x" />
            <strong>Download File</strong>
          </a>
        {/if}
      {/if}
    </div>
    {#if !generatingFile || fileReady}
      <div class="is-flex is-justify-content-center">
        <button
          class="close"
          on:click={close}
          in:fade={{ duration: 250, delay: 250 }}
          out:fade={{ duration: 150 }}
        >
          <i class="far fa-times fa-2x" />
        </button>
      </div>
    {/if}
  </div>
{/if}

<style lang="scss">
  .download-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 75vw;
  }
  .download-options {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
  }
  .light {
    background: rgba($dark, 0.05);
    &:hover {
      background: rgba($dark, 0.1);
    }
  }
  .dark {
    background: rgba($light, 0.05);
    &:hover {
      background: rgba($light, 0.1);
    }
  }
  button {
    border: none;
    padding: 20px 0;
    margin: 0;
    width: 30%;
    border-radius: 5px;
    strong {
      display: block;
      font-size: $fontSize-small;
      margin: 15px 0 0 0;
    }
  }
  .download-button {
    text-align: center;
    display: block;
    padding: 20px 0;
    border-radius: 5px;
    width: 80vw;
    &:hover {
      text-decoration: none;
    }
    strong {
      display: block;
      font-size: $fontSize-small;
      margin: 15px 0 0 0;
    }
  }
  .close {
    width: auto;
    padding: 20px 0;
    background: none;
    width: 100%;
  }
  .loading-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 80vw;
    h3 {
      text-align: center;
      margin: 20px 0;
    }
  }
</style>
